module.exports = __webpack_public_path__ + "img/2.00660a7d.png";